<template>
    <div class="free-months-step">
        <div class="free-months-step__table-wrapper">
            <table id="free_months" class="free-months-step__table">
                <thead>
                    <tr>
                        <th class="free-months-step__header free-months-step__header--year">Year</th>
                        <th
                            v-for="month in expenseMonths"
                            :key="month"
                            class="free-months-step__header free-months-step__header--month"
                        >
                            {{ month }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(row, year) in expense.timeline"
                        :key="year"
                        class="free-months-step__row"
                    >
                        <td class="free-months-step__cell free-months-step__cell--year">
                            {{ year }}
                        </td>
                        <td
                            v-for="(month, monthNumber) in row.months"
                            :key="monthNumber"
                            class="free-months-step__cell free-months-step__cell--checkbox"
                        >
                            <input
                                type="checkbox"
                                class="free-months-step__checkbox"
                                :data-year="year"
                                :data-month="monthNumber"
                                @click="handleClick"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FreeMonthsStep',

    props: {
        expense: {
            type: Object,
            required: true
        },
        expenseMonths: {
            type: Array,
            default: () => []
        }
    },

    methods: {
        handleClick(event) {
            const year = parseInt(event.target.dataset.year);
            const month = parseInt(event.target.dataset.month);
            const checked = event.target.checked;

            this.$emit('set-free-month', { year, month, checked });
        }
    }
};
</script>
